import {RefreshCw} from 'lucide-react';
import * as React from 'react';
import {useSyncUpdatesAvailable} from 'src/hooks/useSyncUpdatesAvailable';
import {useModals} from 'src/Modals';
import {MenuButton} from 'src/SideNav/MenuItem';

export const SyncButton = () => {
  const modals = useModals();
  const updatesAvailable = useSyncUpdatesAvailable();

  const handleClick = () => {
    modals.syncModal.openModal({});
  };

  return (
    <MenuButton
      iconLeft={
        <span className="relative">
          <RefreshCw className="size-4 shrink-0" />
          {updatesAvailable && (
            <span className="absolute -right-1 -top-1 size-2 rounded-full bg-blue-500" />
          )}
        </span>
      }
      label="Sync"
      onClick={handleClick}
    />
  );
};
